<template>
  <q-page :class="{'bg-safeotp': view !='main' || isMobile }">
    <!-- 메인 화면 -->
    <section id="main" v-if="view == 'main'" class="active">
      <article class="full-width">
        <div class="text-center">
          <p v-show="!isMobile" class="subTitle">{{ subTitle }}</p>
          <p v-html="title" class="title"
          :class="{'black': complete}"></p>
        </div>
        <div v-show="!isMobile && !complete" class="background">
          <img src="../images/exercise_background.png" alt="">
        </div>
        <div v-show="!isMobile" class="desktop button_box flex q-gutter-md justify-center">
          <nextButton v-show="!complete" class="next_button" color="blue" btnName="OTP 신청"  
            @click.native="view = 'apply'; saveView('apply');" />
          <nextButton v-show="!complete" class="next_button" btnName="로그인" 
            @click.native="view = 'login'; saveView('login');" />
          <nextButton v-show="complete" class="next_button" color="black" btnName="돌아가기"  
            @click.native="resetExercise()" />
        </div>
      </article>
      <div v-show="isMobile" class="mobile button_box q-pa-md">
        <nextButton v-show="!complete" class="next_button full-width q-mb-sm" color="white" btnName="OTP 신청"  
          @click.native="view = 'apply'; saveView('apply');" />
        <nextButton v-show="!complete" class="next_button full-width" btnName="로그인" 
          @click.native="view = 'login'; saveView('login');" />
        <nextButton v-show="complete" class="next_button full-width" color="black" btnName="돌아가기"  
          @click.native="resetExercise()" />
      </div>  
      <appDownload v-if="!isMobile && !complete" />
    </section>
    <section v-else>
      <div class="section-inner"> 
        <!-- HEADER -->
        <div class="article-header">
          <div v-if="!isMobile">
            <p v-show="view == 'login'"> 로그인 </p>
            <p v-show="view == 'apply'"> OTP <b>신청</b> </p>
          </div> 
          <div v-else>
            <p v-show="view == 'login'"> LOGIN </p>
            <p v-show="view == 'apply'"> OTP <b>신청</b> </p>
          </div>   
        </div>

        <!-- START: CONTENT -->
        <!-- LOGIN -->
        <div v-if="view == 'login'">
          <!-- 1. 로그인 화면 -->
          <article v-show="!certified" class="login article-content"> 
            <div class="form_item">
              <input :class="{'red': validation.firstError('login_uid'), 'blue': login_uid }"
                v-model.trim="login_uid" class="uid" 
                placeholder="아이디" id="login_uid" type="text">
              <span class="underline"></span>
              <p class="validation_message">{{ validation.firstError('login_uid') }}</p>
            </div>
            <div class="form_item q-py-sm check_login">
              <input v-model="pushLogin" type="checkbox" id="check_push">
              <label for="check_push">
                <div class="chk_img"> PUSH 로그인 </div>
              </label>
              <p v-show="pushLogin" class="push_message">
                  OTP App으로만 push 로그인이 가능합니다.
              </p>
            </div>
            <div class="form_item button_box">
              <nextButton class="full-width" btnName="로그인" @click.native="btnCheck()" />
            </div>
          </article>
          <!-- 2. 2차 인증 화면 -->
          <article v-show="certified" class="login article-content">    
            <div v-if="pushLogin === true" class="push_login_box"><!-- push 로그인(OTP앱 인증)할 경우 -->
              <p class="text_noti"> 
                  push 로그인 인증 확인 중 입니다. <br>
                  인증이 정상처리되면 자동으로 페이지가 넘어갑니다.
              </p>  
              <div class="q-py-md" style="min-height: 142px;">
                <p class="showProfile text-center text-bold"> {{ verify_uid }} [{{ verify_typeOf }}] </p> 
                <div class="flex justify-center q-pa-md">
                  <q-spinner-dots color="grey" size="2em"/>   
                </div>
              </div>
            </div>
            <div v-else><!-- push 로그인 아닌 경우 -->
              <p class="showProfile text-bold"> {{ verify_uid }}  [{{ verify_typeOf }}] </p> 
              <div class="form_item q-mt-md">
                <input :class="{'red': validation.firstError('otpNumber'), 'blue': otpNumber }"
                  id="otpNumber" type="text"
                  v-model.trim="otpNumber" class="uid"
                  placeholder="인증번호 입력"/>
                <span class="underline"></span>
                <p class="validation_message">{{ validation.firstError('otpNumber') }}</p>       
              </div>
              <div class="form_item button_box">
                <nextButton class="full-width" btnName="확인" @click.native="validationCheck('verify')" />
              </div>
            </div>
          </article>
        </div>

        <!-- OTP 신청 -->
        <div v-if="view == 'apply'">
          <!-- 1. 신청 화면 -->
          <article v-if="!applied" class="apply article-content">
            <div class="form_item">
              <input :class="{'red': validation.firstError('apply_uid'), 'blue': apply_uid }"
                      v-model.trim="apply_uid" class="uid" 
                      placeholder="아이디" id="apply_uid" type="text">
              <span class="underline"></span>
              <p class="validation_message">{{ validation.firstError('apply_uid') }}</p>
            </div>
            <div class="form_item button_box" >
              <nextButton class="full-width" btnName="OTP 신청" color="blue" @click.native="btnCheck()" />
            </div> 
          </article>
          <!-- OTP 신청 화면 2 -->
          <article v-if="applied" class="applied article-content text-center">  
            <div class="q-gutter-md q-pb-md">
              <p class="showProfile text-center text-bold">
                {{ res_uid }}
              </p>  
              <img class="qrcode" :src="'data:image/jpeg;base64,' + qr" />
              <p class="text_certNumber">{{ certNumber }}</p>
              <p class="text_noti">
                QR코드 또는 인증번호를 OTP App에 등록하신 후, <br> 
                로그인을 진행해주세요. 
              </p>
            </div>
          </article>
        </div>  
        <!-- END: CONTENT -->

        <!-- FOOTER -->
        <div class="article_footer">
          <div v-show="view == 'apply' && applied == true" class="line"></div>
          <div class="text-center button_box">
            <button v-show="view == 'apply'" class="text_btn" @click="changeView()"> 로그인 </button>
            <button v-show="view == 'login' && !certified" class="text_btn" @click="changeView()"> OTP 신청 </button>
          </div>
        </div>
      </div>   
    </section>

    <div v-if="view == 'main' && isMobile" class="main mobile wrap">
      <div class="top img_wrap">
        <img class="circle moveleft" src="../images/exercise_bg_img1.png" alt="">
      </div>
      <div class="bottom img_wrap">
        <img class="circle moveright" src="../images/exercise_bg_img2.png" alt="">
      </div>
    </div>
  </q-page>
</template>
<script>
import Vue from 'vue';
import { mapState, mapActions } from 'vuex'
import SafeOtpService from '../services/SafeOtpService'
import SimpleVueValidation from 'simple-vue-validator'
import NextButton from '../components/NextButton'
import AppDownload from '../components/AppDownload'


const Validator = SimpleVueValidation.Validator
Vue.use(SimpleVueValidation);

export default {
  name: 'Exercise',
  components : {
    'NextButton' : NextButton,
    'appDownload' : AppDownload
  },
  props: {
    isMobile: Boolean
  },
  data(){
    return { 
      view: 'main',
      subTitle: 'Simple, Safe, Speed.',
      title: '편리하고 안전한 <br> <b>SAFEOTP 서비스</b>를<br> 체험해보세요!',
      submitted: false,
      login: false,
      apply: false,
      applied: false,
      certified: false,
      alert: false,
      confirm: false,
      pushLogin: false,
      apply_uid: '',
      login_uid:'',
      res_uid: '',
      res_typeOf: '',
      res_organization: '',
      apply_typeOf : 'OTP',
      apply_email: '',
      apply_phone: '',
      verify_uid: 'id',
      verify_typeOf: 'OTP',
      verify_data: null,
      countDown: false,
      errMessage: '',
      certNumber: '',
      otpNumber: '',
      qr: null,
      random: '',
      complete: false
    }
  },
  created () {
    this.saveView('main')
    this.savePosition('exercise')
  },
  computed: {
    ...mapState ({
      position: state => state.session.position,
      exerciseView: state => state.session.exerciseView
    })
  },
  validators: {
    otpNumber: function(otpNumber) {
      if (this.view != 'login' || !this.certified) {
        return
      }
      return Validator.value(otpNumber).required('인증번호를 입력하세요.')
    },
    login_uid: function(login_uid) {
      if (this.view != 'login') {
        return
      }
      return Validator.value(login_uid).required('ID를 입력하세요.')
    },
    apply_uid: function(apply_uid) {
      if (this.view != 'apply') {
        return
      }
      return Validator.value(apply_uid).required('ID를 입력하세요.')
    }
  },
  methods: {
    ...mapActions({ 
      showAlert: 'alert/showAlert',
      showError: 'alert/showError',
      showMessage: 'alert/showMessage',
      saveView: 'session/save_exerciseView',
      savePosition: 'session/save_position'     
    }),
    resetExercise() {
      this.complete = false
      this.title = '편리하고 안전한 <br> <b>SAFEOTP 서비스</b>를<br> 체험해보세요!'
      this.subTitle = 'Simple. Safe, Speed.'
    },
    btnCheck() {
      if(this.view == 'login') {
        this.validationCheck('request')
      } else if(this.view == 'apply') {
        this.validationCheck('add')
      }
    },
    validationCheck(func) {
      const compontent = this

      if(func == 'add')
        this.submitted = true
     
      this.$validate()
      .then(function(success) {
        if (success) {
          if(func == 'add') 
            compontent.doAdd()
          else if(func == 'register') 
            compontent.doAdd()
          else if(func == 'request') 
            compontent.doRequest()
          else if(func == 'verify') 
            compontent.doVerify()
        } else {
          if(func == 'add') 
            compontent.submitted = false
        }
      })
      .catch(function(error) {
        // console.log('validataion error ,', error)
      })
    },
    initData: function() {
      this.submitted= false
      this.login= false
      this.apply= false
      this.applied= false
      this.certified= false
      this.alert= false
      this.confirm= false
      this.pushLogin= false
      this.login_uid = ''
      this.apply_uid = ''
      this.apply_typeOf = 'OTP'
      this.apply_email = ''
      this.apply_phone= ''
      this.verify_typeOf = ''
      this.verify_data= null
      this.certNumber= ''
      this.otpNumber = ''
      this.qr = null     
      this.random= ''   
    },
    doAdd: function () {
      const vc = this

      let data = {
        id: this.apply_uid,
        typeOf: this.apply_typeOf,
        timestamp: this.$moment().tz("Asia/Seoul").format('YYYY-MM-DD HH:mm:ss z')
      }

      this.$q.loading.show()

      SafeOtpService.apply(data)
      .then((response) => {
        // console.log(response)
        this.$q.loading.hide()
        if(response.success) {
        //   console.log("성공")
          this.res_uid = response.data.id
          this.certNumber = response.data.applyNo 
          this.qr = response.data.applyQR
          this.applied = true
        } else {
        //   console.log("실패")
          var message = response.message
          this.showError({ vc, message })
        }
      })
      .catch((error) => {
        this.$q.loading.hide()
        // console.log('error = '+ error )
        var message = error.message
        this.showError({ vc, message })
      })
    },
    doRequest: function () {
      let data = {
        id: this.login_uid,
        push: this.pushLogin + '',
        timestamp: this.$moment().tz("Asia/Seoul").format('YYYY-MM-DD HH:mm:ss z')
      }
      const vc = this
      this.$q.loading.show()
      SafeOtpService.request(data)
      .then((response) => {
        this.$q.loading.hide()
        // console.log("[doRequest: response]", response)
        if(response.success) {
        //   console.log("성공")
          this.verify_uid = response.data.id
          this.verify_typeOf = response.data.typeOf
          this.random = response.data.random

          this.view = 'login'
          this.saveView('login')

          this.certified = true
          if(this.verify_typeOf ==='OTP' && this.pushLogin)
            this.doVerify()
        } else {
        //   console.log("실패")
          let message = response.message
          this.showError({ vc, message })
        }
      })
      .catch((error) => {
        this.$q.loading.hide()
        // console.log('error = '+ error )
        let message = error.message
        this.showError({ vc, message })
      })
    },
    doVerify: function () {
      let data = {
        id: this.verify_uid,
        timestamp: this.$moment().tz("Asia/Seoul").format('YYYY-MM-DD HH:mm:ss z')
      }

      if(this.pushLogin && this.verify_typeOf === 'OTP') {
        data.otpNumber = this.random
      } else {
        data.otpNumber = this.otpNumber
      }

      this.$q.loading.show()
      const vc = this
      SafeOtpService.verify(data)
      .then((response) => {
        // console.log("[doVerify: response]", response)
         this.$q.loading.hide()
        if(response.success) {
        //   console.log("성공")
          this.initData()
          this.validation.reset()
          // let message = response.data.id + "님, 로그인 되었습니다."
          this.view = 'main'
          this.saveView('main')
          this.complete = true
          this.title = response.data.id + '님, <br> 로그인 되었습니다.'
          this.subTitle = '로그인 완료!'
        } else {
          if( this.position == 'exercise' ) {
            if(this.pushLogin && this.verify_typeOf === 'OTP' && this.view == 'login'){
              setTimeout(function() {
                vc.doVerify()
              }, 2000)
            } else {
              let message = response.message
              this.showError({ vc, message })
            }
          }
        } 
      })
      .catch((error) => {
        this.$q.loading.hide()
        // console.log('error = ', error )
        let message = error.message
        this.showError({ vc, message })
      })
    },
    changeView () {
      if(this.view == 'apply') {
        this.view = 'login'
        this.applied = false
        this.saveView('login')
      } else if(this.view == 'login') {
        this.view = 'apply'
        this.certified = false
        this.saveView('apply')
      }        
      this.initData()
      // console.log(this.validation)
      this.validation.reset()
    }
  }  
}
</script>
<style scoped>
  /* PC & 모바일 공통 */
  /* 페이지 로드 시 애니메이션 */
  @-webkit-keyframes fadein{
    0%   { 
      transform: translateY(100px);
      opacity: 0;
    }
    100% {
      transform: translateY(0px);
      opacity: 1;
    }
  }
  @keyframes moveleft {
    0%{right: 0;}
    100%{right: 100vw;}
  }
  @keyframes moveright {
    0%{left: 0;}
    100%{left: 100vw;}
  }
  @keyframes updown {
    0%{top: 0;}
    100%{top: 10px;}
  }  
  section .title, 
  section .subTitle, 
  section .subTitle-2,
  section .content,
  section .next_button,
  #main .background img {
    opacity: 0;
  }
  section.active .title, 
  section.active .subTitle, 
  section.active .subTitle-2,
  section.active .content,
  section.active .next_button,
  #main.active .background img {
    animation: fadein 1s ease;
    animation-fill-mode: forwards;
  }
  section.active .title {
    animation-delay: .2s!important;
  }
   section.active .content {
     animation-delay: .3s;
  }
  #main.active .background img {
     animation-delay: .4s;
  }
  section.active .next_button {
     animation-delay: .5s;
  }
  /* Button Focus 시 CSS */
  button:focus {
    outline: none!important;
  }
  /* Text Button CSS */
  .text_btn {
    -webkit-appearance: none;
    border: none;
    text-decoration: underline;
    background: none;
    font-size : 13px;
    margin-top: 1.5rem;
  }
  /* 기타 */
  .line {
    border-bottom: 1px solid rgb(160,160,160);
  }
  .validation_message {
    color: #FA5353;
    font-weight: bold;
  }
  .push_message{
    font-size: 80%;
    color: black;
    font-weight: bold;
    margin-top: 10px;
    margin-left: 8px;
  }
  input {
    padding-top: 0px!important;
  }
  p {
    margin-bottom: 0;
  }
  .push_login_box {
    position: absolute; 
    top: 50%; 
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
  }
  .black {
    color: black!important;
    font-size: 3rem!important;
    line-height: 4rem!important;
  }

  /* Input CSS */
  .uid {
    background-color: transparent;
    border: none;
    border-bottom: 4px solid #c7c7c7;
    outline: none;
    width: 100%;
    height: 50px;
    margin-bottom: -16px;
    color: black;
    font-weight: bold;
    padding-bottom: 12px;
    font-size: 17px;
  }
  .uid::-webkit-input-placeholder {
    color: #545454;
    font-weight: 500;
    font-size: 15px!important;
  }
  .uid:focus+.underline {
    transform: scale(1);
  }
  .underline {
    display: inline-block;
    height: 4px;
    width: 100%;
    background-color: #3076FF;
    -webkit-transform: scale(0, 1);
    transform: scale(0, 1);
    -webkit-transition: all 0.2s linear;
    transition: all 0.2s linear;
  }

  /* Border 색상 */
  .red {
    border-color: #FA5353!important;
  }
  .blue {
    border-color: #3076FF!important;
  }

  /* Push Login 체크박스 CSS */
  .check_login input[type="checkbox"] {
    display: none;
  }
  .check_login label {
    width: 100%;
  }
  .check_login input[type="checkbox"] + label .chk_img {
    padding: 0 0 0 40px;
    background:url("../images/exercise_chk1.png")no-repeat;
    cursor:pointer;
  }
  .check_login input[type="checkbox"]:checked + label .chk_img {
    background:url("../images/exercise_chk2.png")no-repeat;
    color: #3076FF;
  }
  .chk_img {
    height: 30px;
    font-size: 15px;
    font-weight: bold;
    margin-top: 20px;
  }

  /*  모바일  */
  /* iPhone 5/SE */
  @media screen and (max-width: 320.98px) {
    #main.title {
      font-size: 2rem;
    }
    .section-inner {
      padding: 2rem!important;
      height: 78%!important;
    }
    .bg-safeotp #main .title {
      font-size: 2.1rem!important;
      line-height: 3rem!important;
      color: white!important;
    }
  }
  @media screen and (min-width: 321px) and (max-width: 599.98px) {
    #main.title {
      font-size: 2rem;
    }
    .section-inner {
      min-height: 460px!important;
    }
    .bg-safeotp #main .title {
      font-size: 2.4rem!important;
      line-height: 3.1rem!important;
      color: white!important;
    }
  }

  @media screen and (min-width: 600px) and (max-width: 768.98px) {
    .bg-safeotp #main .title {
      font-size: 3rem!important;
      line-height: 3.9rem!important;
      color: white!important;
    }
   }
  @media screen and (min-width: 769px) and (max-width: 1023.98px) {
    /* MAIN */
    .background {
      transform: translate(-50%, -60%);
    }
    .background img {
      width: 900px;
    }
    #main .title{
       font-size: 4rem;
       line-height: 80px;
    }
    .bg-safeotp #main .title {
      font-size: 4rem!important;
      line-height: 4.9rem!important;
      color: white!important;
    }
  }
  /* 
    모 바 일     
     공 통 
  */
  @media screen and (max-width: 1023.98px) {
    /* 공통 */
    section {
      height: 100vh!important;
    }
    /* MAIN */
    #main {
    }
    .updown {
      position: relative;
      animation: updown2 1s infinite alternate;  
    }
    .q-page {
      overflow: hidden;
    }
    div.main.wrap {
      position: absolute;
      top: 0;
      height: 100vh;
      width: 100vw;
      z-index: 0;
    }
    section {
      position: relative;
      z-index: 1;
    }
    .moveleft {
      position: absolute;
      animation: updown 1s infinite ease-in alternate, moveleft 200s infinite linear alternate;  
    }
    .moveright {
      position: relative;
      animation: updown 1s infinite ease-in-out alternate, moveright 200s infinite linear alternate;  
    }
    .top.img_wrap {
      position: absolute;
      top: 10vh;
      right: 0;
    }
    .bottom.img_wrap {
      position: absolute;
      bottom: 25vh;
      left: 0;
    }
    .top > .circle {
      height: 100px;
    }
    .bottom > .circle {
      height: 100px;
    }
    #main > article {
      position: absolute; 
      top: 45%; transform: translateY(-50%);
    }
    #main .mobile.button_box {
      width: 100%;
      position: absolute; 
      bottom: 0;
    } 
    .background img {
      width: 900px;
    }

    #main .title{
      font-size: 4rem;
      color: #3076FF;
      line-height: 80px;
    }

    /* OTP 신청 & 로그인 - 공통 */
    .section-inner {
      background: white;
      width: 90%;
      max-width: 400px;
      height: 100%;
      max-height: 480px; 
      position: absolute;   
      top: 50%; 
      left: 50%;
      transform: translate(-50%, -50%);
      border: 1px solid rgb(223,223,223);
      padding: 2rem;
    }
    .article-header {
      font-size: 1rem;
      margin-bottom: 3rem;
      font-weight: 500;
    }
    .article-header p {
      font-size: 30px;
      font-weight: 400;
      color: black;
      margin-top: -10px;
    }
    .article-content .button_box {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 3rem;
      padding: 2rem;
    }
    .showProfile {
      font-size: 12px;
    } 
    .validation_message {
      font-size: 11px!important;
      margin-top: 13px!important;
    }
    .article_footer {
      position: absolute;
      left: 0;
      bottom: 2rem;
      width: 100%;
    }
    /* 로그인 */
    .push_login_box > .text_noti {
      margin-bottom: 5px;
      text-align: center;
      font-size: 80%;
      font-weight: bold;
    }
    #otpNumber {
      font-size: 1.7rem;
    }
    /* OTP 신청 */
    img.qrcode {
      margin-top: 1rem!important;
    }
    .text_certNumber {
      font-size: 1.3rem;
      margin: 1rem 0;
    }
    .applied.article-content .text_noti {
      font-size: 10px;
      color:rgb(160,160,160);
      padding-top: 5px;
    }
  } 
  /*  
    PC 버전 
  */
  @media screen and (min-width: 1024px) {
    section {
      height: 100vh!important;
    }
    /* MAIN */
    #main > article {
      position: absolute; 
      top: 50%; transform: translateY(-50%);
    }
    .background {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -60%);
    }
    .background img {
      width: 900px;
    }
    #main .title{
      color: #3076FF;
      letter-spacing: -5px;
    }
    #main .appDownloadBox {
      z-index: 1000;
      position: absolute;
      bottom: 8%;
      left: 4%;
    }
    #main .desktop.button_box {
      padding-top: 30px;
    } 
    /* OTP 신청 & 로그인 공통 */
    .section-inner {
      background: white;
      width: 400px;
      height: 100%;
      max-height: 480px;
      position: absolute; 
      top: 50%; 
      left: 50%;
      transform: translate(-50%, -50%);
      border: 1px solid rgb(223,223,223);
      padding: 2rem;
    } 
    .article-header {
      margin-bottom: 3rem;
    }
    .article-header p {
      font-size: 30px;
      font-weight: 400;
      color: black;
      margin-top: -10px;
    }
    .article-content .button_box {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 3rem;
      padding: 2rem;
    }
    .validation_message {
      font-size: 12px!important;
      margin-top: 10px!important;
    }
    .article_footer {
      position: absolute;
      left: 0;
      bottom: 2rem;
      width: 100%;
    }
    /* 로그인 */
    #otpNumber {
      font-size: 1.7rem;
    }
    /* OTP 신청 */
    img.qrcode {
      margin-top: 1rem!important;
    }
    .push_login_box > .text_noti {
      margin-bottom: 20px;
      text-align: center;
      font-size: 85%;
      font-weight: bold;
    }
    .applied.article-content .text_noti {
      font-size: 12px;
      padding-top: 5px;
    }
    .text_certNumber {
      font-size: 1.5rem;
    }
  }
  
  @media screen and (min-width: 1024px) and (max-width: 1439.98px){
    /* MAIN */
    .background {
      transform: translate(-55%, -60%);
    }
    .background img {
      width: 1000px;
    }
    #main .title{
      font-size: 5rem;
      line-height: 110px;
    }
    #main .desktop .next_button {
      border-radius: 13px;
      padding-left: 20px;
      width: 280px;
      height: 56px;
    }
    .article-header p {
      font-weight: medium;
      margin-top: -8px;
    }
  }
  @media screen and (min-width: 1440px) {
    /* MAIN */
    .background {
      transform: translate(-53%, -62%);
    }
    .background img{
      width: 1450px;
    }
    #main .title{
      font-size: 7rem;
      line-height: 135px;
    }
    #main .desktop.button_box {
      padding-top: 60px!important;
    }
    #main .desktop .next_button {
      border-radius: 13px;
      padding-left: 20px;
      width: 330px;
      height: 68px;
      font-size: 17px;
    }
    .article-header p {
      font-weight: medium;
      margin-top: -8px;
    }
  }
</style>

